import { Card } from "soapbox/components/ui/card.tsx";

const PrivacyPolicyPage: React.FC = () => {
  const html = `
<h1>Privacy Policy for TrueMaple</h1>

<p><strong>Effective Date:</strong> January 28, 2026</p>

<p>At TrueMaple, your privacy is important. This Privacy Policy explains how we collect, use, and protect your information when you use our platform. By using TrueMaple, you agree to this policy.</p>

<section>
    <h2>1. Information We Collect</h2>
    <p>When you use TrueMaple, we may collect:</p>
    
    <h3>Account Information:</h3>
    <ul>
        <li>Name, email address, username, password</li>
        <li>Profile information like bio and profile picture</li>
    </ul>
    
    <h3>Content You Post:</h3>
    <ul>
        <li>Posts, comments, images, videos, or links</li>
        <li>Metadata like timestamps, location (if enabled), and device information</li>
    </ul>
    
    <h3>Usage Information:</h3>
    <ul>
        <li>How you interact with the platform (e.g., clicks, views, searches)</li>
        <li>Device and browser type, IP address, and operating system</li>
    </ul>
    
    <h3>Cookies &amp; Tracking:</h3>
    <p>We use cookies and similar technologies to improve your experience, remember your preferences, and show relevant content</p>
</section>

<section>
    <h2>2. How We Use Your Information</h2>
    <p>We use your information to:</p>
    <ul>
        <li>Provide and operate TrueMaple</li>
        <li>Improve and personalize your experience</li>
        <li>Communicate with you about your account or updates</li>
        <li>Display content and ads, including using your content to promote TrueMaple</li>
        <li>Detect, prevent, and respond to fraud, abuse, or legal violations</li>
    </ul>
</section>

<section>
    <h2>3. How We Share Your Information</h2>
    <p>We respect your privacy and will never sell your personal information. We may share information:</p>
    <ul>
        <li>With service providers who help us operate TrueMaple (e.g., hosting, analytics, email delivery)</li>
        <li>When required by law or to protect our rights and users</li>
        <li>In aggregated or anonymized form that cannot identify you personally</li>
    </ul>
</section>

<section>
    <h2>4. Content Posted Publicly</h2>
    <p>Content you post publicly on TrueMaple may be seen by other users and used to promote TrueMaple (including in ads, social media, or marketing materials).</p>
</section>

<section>
    <h2>5. Your Choices</h2>
    <ul>
        <li><strong>Profile visibility:</strong> You can make your profile private or public.</li>
        <li><strong>Sensitive content:</strong> Mark your posts as sensitive if they contain nudity or adult content.</li>
        <li><strong>Cookies:</strong> You can manage or disable cookies through your browser settings.</li>
    </ul>
</section>

<section>
    <h2>6. Data Retention</h2>
    <p>We retain your data as long as necessary to provide our services or comply with legal obligations. You can request deletion of your account, and we will remove your personal information, though some data may remain for legal or technical reasons.</p>
</section>

<section>
    <h2>7. Security</h2>
    <p>We take reasonable measures to protect your data, including encryption and secure servers. However, no system is completely secure, and we cannot guarantee absolute protection.</p>
</section>

<section>
    <h2>8. Children's Privacy</h2>
    <p>TrueMaple is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
</section>

<section>
    <h2>9. International Users</h2>
    <p>TrueMaple is based in Canada. By using the platform, you consent to the transfer and storage of your information in Canada and other countries where we operate.</p>
</section>

<section>
    <h2>10. Changes to this Privacy Policy</h2>
    <p>We may update this Privacy Policy from time to time. Significant changes will be communicated on the platform. Continued use constitutes acceptance of the updated policy.</p>
</section>

<section>
    <h2>11. Contact Us</h2>
    <p>If you have questions about this Privacy Policy, please contact us at:</p>
    <p><strong>Email:</strong> <a href="mailto:support@truemaple.net">support@truemaple.net</a></p>
</section>`;

  return (
    <Card variant="rounded">
      <div className="prose mx-auto py-4 dark:prose-invert sm:p-6">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </Card>
  );
};

export default PrivacyPolicyPage;
